import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
  icon: ReactNode
  title?: ReactNode | string
  content?: ReactNode | string
}

// I think this component should reside here instead of src/components, because it is
// encapsulated here and not intended for explicit use anywhere else
export const ToastLayout: React.FC<Props> = ({ icon, title, content }) => {
  return (
    <ContentWrapper>
      <IconWrapper>{icon}</IconWrapper>
      <TextWrapper>
        {title && <TitleWrapper>{title}</TitleWrapper>}
        <MainText>{content}</MainText>
      </TextWrapper>
    </ContentWrapper>
  )
}

const TextWrapper = styled.div``

const ContentWrapper = styled.div`
  display: flex;
`
const IconWrapper = styled.div`
  margin-right: 10px;
`

const TitleWrapper = styled.strong`
  text-align: left;
  padding-bottom: 10px;
`

const MainText = styled.div`
  text-align: left;
  line-height: 22px;

  a {
    color: inherit;
    text-decoration: underline;
  }
`

export const Subtitle = styled.div`
  padding-bottom: 10px;
`

export type ToastLayoutProps = Props
